import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1rem',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    minHeight: '35rem',
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    padding: '2rem',
    paddingTop: '1rem',
    backgroundColor: theme.palette.container.background,
  },
}));

export default useStyles;
